<template>
  <div class="home">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/coding-questions` }">Coding Questions</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `${currentClientId}/coding-questions/${$route.params.id}` }">{{$route.params.id}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>
    <div v-if="!loading" class="top-margin" disabled="!isCodingQuestion()">
      <el-form id="codingQuestionForm" label-position="top" size="mini" style="margin: 20px 10px 10px 10px;" :model="codingQuestion" :rules="rules" ref="codingQuestionForm">
        <el-row :gutter="20">
          <el-col :span="4" v-if="!isNew">
            <el-form-item prop="status" label="Status">
              <el-select :disabled="!documentManagerAdmin()" v-model="status" @change="putCodingQuestion('status')">
                <el-option v-for="s in codingQuestionStatusList" :key="s.id" :label="s.status" :value="s.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="assignedTo" label="Assigned To">
              <el-select :disabled="!documentManagerAdmin()" v-model="assignedTo" @change="putCodingQuestion('assignedTo')">
                <el-option v-for="c in consultantList" :key="c.key" :label="c.value" :value="c.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Created By">
              <el-input disabled type="text" v-model="codingQuestion.createdBy"></el-input>
            </el-form-item>
            <el-form-item label="Created">
              <el-input disabled type="text" v-model="insertDate"></el-input>
            </el-form-item>
            <el-form-item label="Last Modified">
              <el-input disabled type="text" v-model="lastModified"></el-input>
            </el-form-item>
            <i v-if="!isNew" class="mdi mdi-paperclip addAttachment" @click="openUploadDialog"> Add Attachment</i>
            <input id="fileUpload" style="display: none;" type="file" @change="handleFileUpload" multiple>
            <ul v-loading="deletingAttachmentLoading" element-loading-spinner="nucleus-loader" class="attachmentsList">
              <li v-for="attachment in codingQuestion.codingQuestionsAttachments.filter(x => !x.deleteDate)" :key="attachment.attachmentId">
                <i class="el-icon-close" title="Delete attachment" @click="deleteAttachment(attachment)"> </i>
                <span @click="downloadAttachment(attachment)">{{getAttachmentName(attachment.name)}}</span>
              </li>
            </ul>
          </el-col>
          <el-col :span="20" :offset="isNew ? 2 : 0" v-loading="postLoading" element-loading-spinner="nucleus-loader">

            <el-alert v-if="received" type="success" style="margin-bottom: 20px;">
              Thank you, we have received your coding question. You can continue to edit your question or
              <router-link :to="`/${currentClientId}/coding-questions`">return to the coding questions list.
              </router-link>
            </el-alert>

            <el-button v-if="isNew" @click="postCodingQuestion" type="primary" icon="el-icon-plus" class="pull-right" style="position:relative; top: 0px;" :disabled="!isCodingQuestion()">Submit
              Question
            </el-button>
            <el-button v-if="!isNew" @click="handleExport" type="primary" icon="el-icon-document" class="pull-right" style="position:relative; top: 0px;">Export
            </el-button>

            <el-form-item prop="questionType" label="Question Type">
              <input type="radio" name="facilityType" value="Acute" v-model="questionType" @change="putCodingQuestion('questionType')">Acute
              <input type="radio" name="facilityType" value="Professional Fee" v-model="questionType" @change="putCodingQuestion('questionType')">Professional Fee
            </el-form-item>
            <el-form-item prop="title" label="Question Title">
              <el-input type="text" v-model="title" @change="putCodingQuestion('title')"></el-input>
            </el-form-item>
            <el-collapse id="codingQuestionCollapse" v-model="activeName">
              <el-collapse-item name="1" class="firstQuestion">
                <template slot="title">
                  <el-form-item prop="question">
                    <template slot="label">
                      Question
                      <el-tooltip class="labelTooltip" effect="dark" content="Enter your question.  Be specific - generalized questions will be returned unanswered.
                                              Specific: “Should I use chest pain non-cardiac, GERD, or CAD as principal diagnosis?”
                                                General: “What is the principal diagnosis?” or “How do I code this chart?”" placement="top">
                        <i class="mdi mdi-information"></i>
                      </el-tooltip>
                    </template>
                  </el-form-item>
                </template>
                <div v-show="!showQuestionTinyMce" style="width: 100%; display: inline-block;">
                  <div tabindex="0" class="richText" data-placeholder="Enter your question.  Be specific - generalized questions will be returned unanswered.
                                    Specific: “Should I use chest pain non-cardiac, GERD, or CAD as principal diagnosis?”
                                      General: “What is the principal diagnosis?” or “How do I code this chart?”" v-html="question"
                    @click="showTinyMce('showQuestionTinyMce')"></div>
                </div>
                <div v-show="showQuestionTinyMce">
                  <Tinymce id="question" ref="showQuestionTinyMce" style="width: 100%" v-model="question" :imagePath="tinyMceImagePath"
                    @change="putCodingQuestion('question')">
                  </Tinymce>
                </div>
              </el-collapse-item>

              <el-collapse-item name="2">
                <template slot="title">
                  <el-form-item prop="codeList">
                    <template slot="label">
                      Code List
                      <el-tooltip class="labelTooltip" effect="dark"
                        content="Provide the complete list of codes you have assigned for this case.  For educational purposes, an inquiry form will be returned unanswered if the original coding is not included."
                        placement="top">
                        <i class="mdi mdi-information"></i>
                      </el-tooltip>
                    </template>
                  </el-form-item>
                </template>
                <div v-show="!showCodeListTinyMce" style="width: 100%; display: inline-block;">
                  <div tabindex="0" class="richText"
                    data-placeholder="Provide the complete list of codes you have assigned for this case.  For educational purposes, an inquiry form will be returned unanswered if the original coding is not included."
                    v-html="codeList" @click="showTinyMce('showCodeListTinyMce')"></div>
                </div>
                <div v-show="showCodeListTinyMce">
                  <Tinymce id="codeList" ref="showCodeListTinyMce" style="width: 100%;" v-model="codeList" :imagePath="tinyMceImagePath"
                    @change="putCodingQuestion('codeList')">
                  </Tinymce>
                </div>
              </el-collapse-item>

              <el-collapse-item name="3">
                <template slot="title">
                  <el-form-item prop="references">
                    <template slot="label">
                      References
                      <el-tooltip class="labelTooltip" effect="dark"
                        content="List specific references you have already researched.  Provide Coding Clinic issue, quarter, page, etc, or copy and paste below into the space.  It is expected that coders will first do research on known resources before submission of the question."
                        placement="top">
                        <i class="mdi mdi-information"></i>
                      </el-tooltip>
                    </template>
                  </el-form-item>
                </template>
                <div v-show="!showReferencesTinyMce" style="width: 100%; display: inline-block;">
                  <div tabindex="0" class="richText"
                    data-placeholder="List specific references you have already researched.  Provide Coding Clinic issue, quarter, page, etc, or copy and paste below into the space.  It is expected that coders will first do research on known resources before submission of the question."
                    v-html="references" @click="showTinyMce('showReferencesTinyMce')"></div>
                </div>
                <div v-show="showReferencesTinyMce">
                  <Tinymce id="references" ref="showReferencesTinyMce" style="width: 100%" v-model="references" :imagePath="tinyMceImagePath"
                    @change="putCodingQuestion('references')">
                  </Tinymce>
                </div>
              </el-collapse-item>

              <el-collapse-item name="4">
                <template slot="title">
                  <el-form-item prop="otherSources">
                    <template slot="label">
                      Other Sources
                      <el-tooltip class="labelTooltip" effect="dark"
                        content="Have you discussed this case with any other source (eg. Provider, Manager, 3M, etc.)?  If so, include response and source below."
                        placement="top">
                        <i class="mdi mdi-information"></i>
                      </el-tooltip>
                    </template>
                  </el-form-item>
                </template>
                <div v-show="!showOtherSourcesTinyMce" style="width: 100%; display: inline-block;">
                  <div tabindex="0" class="richText"
                    data-placeholder="Have you discussed this case with any other source (eg. Provider, Manager, 3M, etc.)?  If so, include response and source below."
                    v-html="otherSources" @click="showTinyMce('showOtherSourcesTinyMce')"></div>
                </div>
                <div v-show="showOtherSourcesTinyMce">
                  <Tinymce id="otherSources" ref="showOtherSourcesTinyMce" style="width: 100%" v-model="otherSources" :imagePath="tinyMceImagePath"
                    @change="putCodingQuestion('otherSources')">
                  </Tinymce>
                </div>
              </el-collapse-item>

              <el-collapse-item name="5" v-show="!isNew">
                <template slot="title">
                  <el-form-item prop="answer" v-if="!isNew">
                    <template slot="label">
                      <span style="margin-left: 14px;">HIA Response</span>
                    </template>
                  </el-form-item>
                </template>
                <div v-show="!showAnswerTinyMce" style="width: 100%; display: inline-block;">
                  <div tabindex="0" class="richText" v-html="answer" :class="{'disabledRichText': !documentManagerAdmin()}"
                    @click="() => { if (documentManagerAdmin()) showTinyMce('showAnswerTinyMce') }"></div>
                </div>
                <div v-show="showAnswerTinyMce">
                  <Tinymce id="answer" ref="showAnswerTinyMce" style="width: 100%" v-model="answer" :imagePath="tinyMceImagePath" @change="putCodingQuestion('answer')">
                  </Tinymce>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div v-show="!isNew">
              <h4><strong>Comments</strong></h4>
              <div v-for="comment in codingQuestion.codingQuestionsComments" :key="comment.commentId">
                {{comment.createdBy}} on <i>{{format(parseISO(comment.insertDate), 'M/d/yyyy hh:mm a')}}</i>
                <div class="commentRichText" v-html="comment.comment"></div>
              </div>
              <div v-show="!showCommentTinyMce" :disabled="!isCodingQuestion()">
                <div v-loading="commentLoading" element-loading-spinner="nucleus-loader" class="richText" style="margin-left: 20px;"
                  data-placeholder="Click to add new comment" v-html="newComment" @click="showTinyMce('showCommentTinyMce')"></div>
              </div>
              <div v-show="showCommentTinyMce" style="margin-left: 20px;" >
                <Tinymce id="newComment" ref="showCommentTinyMce" style="width: 100%;" v-model="newComment" :imagePath="tinyMceImagePath">
                </Tinymce>
              </div>
              <el-button type="primary" style="margin-left: 20px; margin-top: 10px;" :disabled="!newComment && !showCommentTinyMce && !isCodingQuestion()" @click="postComment">
                Add Comment</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog title="Upload Details" :visible.sync="fileOperationsDialogVisible" width="50%" :before-close="closeFileOperationsDialog" :close-on-click-modal="false">
      <el-table id="fileOperationDialogTable" :data="filesToOperateOn" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="name" label="" min-width="200" class-name="document-item">
        </el-table-column>
        <el-table-column prop="statusMessage" label="" min-width="80">
        </el-table-column>
        <el-table-column prop="percentCompleted" label="" min-width="30">
          <template slot-scope="scope">
            <el-progress type="circle" :percentage="scope.row.percentCompleted" :status="scope.row.progressStatus" :width="45" :color="scope.row.progressColor">
              {{scope.row.progressStatus === 'text' ? `${scope.row.percentCompleted}%` : ''}}
            </el-progress>
          </template>
        </el-table-column>
        <template slot="empty">
          <p> No Documents Available</p>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFileOperationsDialog">Close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import { format, parseISO } from 'date-fns'
  import { mapState, mapActions, mapMutations } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import { createHelpers } from 'vuex-map-fields'
  import Tinymce from '@/components/Tinymce'

  const { mapFields } = createHelpers({
    getterType: 'codingQuestions/getField',
    mutationType: 'codingQuestions/updateField'
  })

  export default {
    mixins: [HiaAuthorization],
    data: function () {
      return {
        loading: true,
        received: false,
        postLoading: false,
        commentLoading: false,
        deletingAttachmentLoading: false,
        fileOperationsDialogVisible: false,
        filesToOperateOn: [],
        files: [],
        format: format,
        parseISO: parseISO,
        showQuestionTinyMce: false,
        showCodeListTinyMce: false,
        showOtherSourcesTinyMce: false,
        showReferencesTinyMce: false,
        showAnswerTinyMce: false,
        showCommentTinyMce: false,
        newComment: '',
        rules: {
          title: [
            { required: true, message: 'Please Enter Title', trigger: 'none' }
          ],
          question: [
            { required: true, message: 'Please Enter Question', trigger: 'none' }
          ],
          references: [
            { required: true, message: 'Please Enter References', trigger: 'none' }
          ],
          codeList: [
            { required: true, message: 'Please Enter Code List', trigger: 'none' }
          ],
          otherSources: [
            { required: true, message: 'Please Enter Other Sources', trigger: 'none' }
          ]
        },
        activeName: []
      }
    },
    name: 'codingQuestion',
    components: {
      Tinymce
    },
    methods: {
      ...mapActions('codingQuestions/', ['GET_CODING_QUESTION', 'POST_CODING_QUESTION', 'PUT_CODING_QUESTION', 'GET_CODING_QUESTION_STATUS_LIST', 'POST_CODING_QUESTION_COMMENT', 'POST_ATTACHMENT', 'DELETE_ATTACHMENT', 'GET_ATTACHMENT_LINK', 'GET_CONSULTANT_LIST', 'GET_CODINGQUESTION_PDF_URL']),
      ...mapMutations('codingQuestions/', ['SET_CODING_QUESTION']),
      initialize() {
        this.loading = true
        let promiseList = [this.GET_CODING_QUESTION_STATUS_LIST(), this.GET_CONSULTANT_LIST()]

        if (!this.isNew) {
          promiseList.push(this.GET_CODING_QUESTION(this.$route.params.id))
        } else {
          this.SET_CODING_QUESTION({
            questionType: 'Acute',
            title: '',
            question: '',
            codeList: '',
            references: '',
            otherSources: '',
            answer: '',
            status: 1,
            codingQuestionsAttachments: [],
            codingQuestionsComments: []
          })
          this.activeName = ['1', '2', '3', '4']
        }

        Promise.all(promiseList).then(() => {
          this.loading = false
        }, error => {
          console.log(error)
          this.$message({
            message: 'Error Loading Coding Question',
            type: 'error'
          })
          this.loading = false
        })
      },
      putCodingQuestion(field) {
        if (this.$route.params.id === 'new') {
          return
        }

        this.$refs.codingQuestionForm.validateField(field, errorMsg => {
          if (!errorMsg) {
            let payload = {
              changedField: field,
              codingQuestion: this.codingQuestion
            }

            this.PUT_CODING_QUESTION(payload).then(() => {
              this.$message({
                message: 'Coding Question Saved',
                type: 'success'
              })
            }, error => {
              console.log(error)
              this.$message({
                message: 'Error Saving Coding Question',
                type: 'error'
              })
            })
          }
        })
      },
      postCodingQuestion() {
        this.$refs.codingQuestionForm.validate((valid) => {
          if (valid) {
            this.postLoading = true
            this.POST_CODING_QUESTION(this.codingQuestion).then((response) => {
              this.postLoading = false
              this.received = true
              this.$router.push({ name: 'codingQuestion', params: { id: response.questionId } })
              this.$message({
                message: 'Coding Question Created',
                type: 'success'
              })
            }, error => {
              console.log(error)
              this.postLoading = false
              this.$message({
                message: 'Error Creating Coding Question',
                type: 'error'
              })
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      async postComment() {
        if (!this.newComment) {
          this.$message({
            message: 'Comment Field Can Not Be Empty',
            type: 'error'
          })
          return
        }
        const inProgress = 2
        // check if status == 2 if it is, prompt to change
        if (this.codingQuestion.status !== inProgress) {
          // prompt to user
          try {
            await this.$confirm('Adding a comment will re-open the question. Continue?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            })
          } catch (e) {
            return
          }
        }

        this.commentLoading = true
        let payload = {
          questionId: this.codingQuestion.questionId,
          comment: this.newComment
        }
        this.POST_CODING_QUESTION_COMMENT(payload).then(() => {
          this.codingQuestion.status = inProgress // when new comment added, make in-progress
          this.newComment = ''
          this.commentLoading = false
          this.$message({
            message: 'Comment Added',
            type: 'success'
          })
        }, error => {
          console.log(error)
          this.commentLoading = false
          this.$message({
            message: 'Error Adding Comment',
            type: 'error'
          })
        })
      },
      showTinyMce(showFlag) {
        this[showFlag] = true

        let handler = (e) => {
          // check for tiny mce dropdown mouse click; tiny mce dropdowns live at the bottom of the DOM
          let tinyMceClick = false

          if (e.path && e.path.length) {
            let classCheck = ['tox', 'tox-silver-sink', 'tox-tinymce-aux', 'tox-textfield']
            e.path.forEach((v, i) => {
              if (v.classList !== undefined && classCheck.some(x => v.classList.contains(x))) {
                tinyMceClick = true
              }
            })
          }

          // exclude Tiny Spell Check dialog
          let dialogElements = document.querySelectorAll('div[role="dialog"].tox-dialog')

          if (dialogElements && dialogElements.length === 1) {
            let container = dialogElements[0]
            if (container.contains(e.target)) {
              tinyMceClick = true
            }
          }

          // only close if the click is outside of tinymce
          if (!this.$refs[showFlag].$el.nextElementSibling.contains(e.target) && !tinyMceClick) {
            this.$nextTick(() => {
              this[showFlag] = false
              document.removeEventListener('click', handler, false)
            })
          }
        }

        // doesn't work
        // this.$nextTick(() => {
        //   this.$refs[showFlag].focus()
        //   document.addEventListener('click', handler, false)
        // })

        // works
        setTimeout(() => {
          this.$refs[showFlag].focus()
          document.addEventListener('click', handler, false)
        }, 50)
      },
      openUploadDialog() {
        document.getElementById('fileUpload').click()
      },
      postFilesRecursive(filesToUpload, i) {
        return new Promise((resolve) => {
          filesToUpload[i].loadingStatus = 'loading'
          filesToUpload[i].statusMessage = 'uploading...'
          filesToUpload[i].questionId = this.$route.params.id

          filesToUpload[i].onUploadProgress = (progressEvent) => {
            filesToUpload[i].percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            if (filesToUpload[i].percentCompleted >= 90) {
              filesToUpload[i].percentCompleted = 90
              filesToUpload[i].statusMessage = 'almost done...'
            }
          }

          if (i === 0) {
            this.fileOperationsDialogTitle = 'Upload Details'
            this.fileOperationsDialogVisible = true
          }

          this.POST_ATTACHMENT(filesToUpload[i]).then(() => {
            filesToUpload[i].loadingStatus = 'done'
            filesToUpload[i].statusMessage = 'done'
            filesToUpload[i].progressStatus = 'success'
            filesToUpload[i].percentCompleted = 100

            if (i === filesToUpload.length - 1) {
              this.loading = false
              resolve()
            } else {
              resolve(this.postFilesRecursive(filesToUpload, i + 1))
            }
          }, error => {
            filesToUpload[i].loadingStatus = 'error'
            filesToUpload[i].progressStatus = 'exception'
            filesToUpload[i].progressColor = '#FF3232'
            filesToUpload[i].percentCompleted = 100

            if (error.response) {
              filesToUpload[i].statusMessage = error.response.data.message
            }

            if (i === filesToUpload.length - 1) {
              this.loading = false
              resolve()
            } else {
              resolve(this.postFilesRecursive(filesToUpload, i + 1))
            }
          })
        })
      },
      handleFileUpload(e) {
        this.filesToOperateOn = []
        let tempFiles = e.target.files
        const totalCount = tempFiles.length
        if (totalCount > 0) {
          this.loading = true
          for (let i = 0; i < totalCount; i++) {
            this.filesToOperateOn.push({
              attachment: tempFiles[i],
              name: tempFiles[i].name,
              directory: this.parentDirectoryNavigation,
              statusMessage: '',
              loadingStatus: '',
              percentCompleted: 0,
              onUploadProgress: {},
              progressStatus: 'text',
              progressColor: '#7CBE5F'
            })
          }
          this.postFilesRecursive(this.filesToOperateOn, 0).then(() => {
          })
        }
      },
      closeFileOperationsDialog() {
        this.fileOperationsDialogVisible = false
        this.fileToOperateOn = []
      },
      getAttachmentName(fullName) {
        let parts = fullName.split('/')
        return parts[parts.length - 1]
      },
      generateDownloadLink(href) {
        let link = document.createElement('a')
        link.setAttribute('style', 'display: hidden;')
        link.setAttribute('download', 'download')
        link.id = 'hiddenLink'
        link.href = `${process.env.VUE_APP_API_BASE_URL}${href}`
        document.getElementsByTagName('body')[0].appendChild(link)
        document.getElementById('hiddenLink').click()
        // remove link
        let timerId = setInterval(() => {
          document.getElementById('hiddenLink').remove()
          clearInterval(timerId)
        }, 500)
      },
      downloadAttachment(attachment) {
        this.GET_ATTACHMENT_LINK(attachment).then(response => {
          this.generateDownloadLink(response)
        }, error => {
          console.log(error)
          this.$message({
            message: 'Error Downloading Attachment',
            type: 'error'
          })
        })
      },
      handleExport(projectId) {
        const loading = this.$loading({
          lock: true,
          text: 'Getting ready...',
          spinner: 'nucleus-loader',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        this.GET_CODINGQUESTION_PDF_URL(this.codingQuestion.questionId).then(response => {
          loading.close()
          window.open(`/static/pdfjs/web/viewer.html?file=${response}`, '_blank')
        })
      },
      openPDFViewer(newWindow, response) {
        var byteCharacters = atob(response)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], {
          type: 'application/pdf'
        })
        var url = window.URL.createObjectURL(blob)
        var viewerUrl = '/static/pdfjs/web/viewer.html?file=' + encodeURI(url)
        newWindow.location.href = viewerUrl
      },
      deleteAttachment(attachment) {
        this.$confirm('Are you sure you want to delete this attachment?', 'Delete items', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.deletingAttachmentLoading = true
          this.DELETE_ATTACHMENT(attachment).then(() => {
            this.deletingAttachmentLoading = false
          })
        })
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId', 'clients']),
      ...mapState('codingQuestions/', ['codingQuestion', 'codingQuestionStatusList', 'consultantList']),
      ...mapFields(['codingQuestion.title',
        'codingQuestion.question',
        'codingQuestion.codeList',
        'codingQuestion.references',
        'codingQuestion.otherSources',
        'codingQuestion.answer',
        'codingQuestion.status',
        'codingQuestion.assignedTo',
        'codingQuestion.questionType'
      ]),
      insertDate() {
        if (this.codingQuestion.insertDate) {
          return format(parseISO(this.codingQuestion.insertDate), 'M/d/yyyy hh:mm a')
        }
        return ''
      },
      lastModified() {
        if (this.codingQuestion.lastModified) {
          return format(parseISO(this.codingQuestion.lastModified), 'M/d/yyyy hh:mm a')
        }
        return ''
      },
      tinyMceImagePath() {
        return `codingquestions/${this.codingQuestion.questionId}/`
      },
      isNew() {
        return this.$route.params.id === 'new'
      }
    }
  }
</script>

<style scoped>
  >>>.el-form-item__content {
    line-height: 1px;
  }

  .richText {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    min-height: 125px;
    overflow-y: auto;
    line-height: 18px;
  }

  /*   .richText:hover {
    background: #DCDFE6;
  } */

  .is-error .richText {
    border: 1px solid #f56c6c;
  }

  .disabledRichText {
    border: 1px solid #dcdfe6;
    background: #e5eef4;
    border-radius: 4px;
    padding: 5px;
    min-height: 30px;
    cursor: unset;
  }

  .commentRichText {
    border: 1px solid #dcdfe6;
    background: #e5eef4;
    border-radius: 4px;
    padding: 5px;
    margin: 10px 0 20px 20px;
    min-height: 30px;
  }

  .addAttachment:hover {
    cursor: pointer;
    color: #337ab7;
  }

  .attachmentsList {
    list-style: none;
    margin: 5px 0px 5px 0px;
    padding: 0px;
  }

  .attachmentsList li {
    font-size: 15px;
  }

  .attachmentsList li:hover {
    cursor: pointer;
    color: #337ab7;
  }

  .attachmentsList li:hover i {
    visibility: visible;
  }

  .attachmentsList li i {
    margin-top: 1px;
    /* visibility: hidden; */
  }

  div:empty:before {
    content: attr(data-placeholder);
    color: gray;
  }

  >>>.el-input.is-disabled input {
    color: #606266 !important;
  }

  >>>.labelTooltip {
    position: relative;
    z-index: 1000;
  }

  #codingQuestionCollapse>>>.el-collapse-item>div>div>div>div>.el-form-item__error {
    margin: -8px;
    margin-left: 0px;
    width: 300px;
  }

  #codingQuestionCollapse>>>.el-collapse-item>div>div>div>.el-form-item__label {
    margin-top: 20px;
    font-weight: normal;
  }

  #codingQuestionCollapse>>>.el-collapse-item__header {
    height: 45px;
    line-height: 45px;
    padding-left: 10px;
    border-bottom: 1px solid #ebeef5;
    color: #606266;
    font-weight: 500;
  }

  #codingQuestionCollapse>>>.firstQuestion>div>.el-collapse-item__header {
    border-top: 1px solid #ebeef5;
  }

  >>>.el-form--label-top .el-form-item__label {
    padding: 0px 12px 0px 0px;
  }
</style>
